import React from 'react'

import { t } from 'src/translations'
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay
} from 'shared/components/common/modal'
import {
  PopoverContextProvider,
  usePopoverContext
} from 'shared/components/common/popover/PopoverContext'
import Cart from 'public/components/default_template/online_ordering/cart/Cart'

import ConvoOrdering from './ConvoOrdering'

const POPOVER_CONTEXT_KEY = 'convoOrderingPopover'

const ConvoOrderingModal: React.FC = () => {
  const popoverContext = usePopoverContext(POPOVER_CONTEXT_KEY)

  const onClose = () => {
    popoverContext?.close()
  }

  if (!popoverContext) {
    return null
  }

  return (
    <>
      <ConvoOrderingModalIconButton
        isModalOpen={popoverContext.isOpen}
        onClick={popoverContext.open}
      />
      <Modal
        isOpen={popoverContext.isOpen}
        onClose={onClose}
        className='convoOrderingModal'
      >
        <ModalOverlay fadeIn fadeOut />
        <ModalContent
          wrapperClassName='wrapper'
          contentClassName='content'
          slideIn
          slideOut
          ariaLabelledBy='convoOrdering-label'
        >
          <div className='header'>
            <div id='convoOrdering-label' tabIndex={-1}>
              {t('convo-ordering-modal.your-order')}
            </div>
            <ModalCloseButton className='closeButton' />
          </div>
          <div className='mainContent'>
            <div className='leftPanel'>
              <ConvoOrdering />
            </div>
            <div className='rightPanel'>
              <Cart />
            </div>
          </div>
        </ModalContent>
      </Modal>
    </>
  )
}

type ConvoOrderingModalIconButtonProps = {
  isModalOpen?: boolean
  onClick?: () => void
}

const ConvoOrderingModalIconButton: React.FC<
  ConvoOrderingModalIconButtonProps
> = ({ isModalOpen, onClick } = {}) => (
  <button className='userNav' aria-expanded={isModalOpen} onClick={onClick}>
    <div>✨</div>
  </button>
)

const WrappedConvoOrderingModal = () => (
  <PopoverContextProvider contextKey={POPOVER_CONTEXT_KEY}>
    <ConvoOrderingModal />
  </PopoverContextProvider>
)
export default WrappedConvoOrderingModal
